import React, { useEffect, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import LastPageIcon from "@mui/icons-material/LastPage";
import { useLocation, useNavigate } from "react-router-dom";
import { fetchQuery } from "../../../utils/commonComponent/fetched";
import ListSearchSection from "../../../utils/Custom/ListSearchSection";
import { AddButton } from "../../../utils/Custom/Button";
import { submitSiteDelete } from "../../../utils/commonComponent/delete";
import moment from "moment";
import { getPermissions } from "../rbac/hasAccess";
import { paginationrowsPerPageOptions } from "../../../utils/commonComponent/commonConstant";

const headers = ["id", "letterNumber", "clientName"];

const fields = [
  { value: "letterNumber", label: "Letter Number" },
  { value: "clientName", label: "Client Name" },
];

const GeneralCorrespondentsList = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const permissions = getPermissions(props.moduleId);
  const handleEdit = (row) => navigate(`/editgeneralCorrespondents/${row.id}`);
  const handleDelete = (row) => submitSiteDelete("GeneralCorrespondents", row.id);

  const [CorrespondentsList, setCorrespondentsList] = React.useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [searchBy, setSearchBy] = React.useState(sessionStorage.getItem("searchBy") || "letterNumber");
  const [searchKey, setSearchKey] = React.useState(sessionStorage.getItem("searchKey") || "");
  const [searched, setSearched] = React.useState(sessionStorage.getItem("searched") === "true" || false);
  // Pagination
  const [currentPage, setCurrentPage] = useState(() => Number(sessionStorage.getItem("ListPageCount") || 0));
  const [rowsPerPage, setRowsPerPage] = useState(() => Number(sessionStorage.getItem("ListRowsPerPage") || 30));

  const totalPages = Math.ceil(CorrespondentsList.length / rowsPerPage);
  const paginatedData = CorrespondentsList.slice(
    currentPage * rowsPerPage,
    currentPage * rowsPerPage + rowsPerPage
  );

  const handleChangePage = (newPage) => {
     if (newPage >= 0 && newPage < totalPages) {
      setCurrentPage(newPage);
      sessionStorage.setItem("currentPath", location.pathname);
      sessionStorage.setItem("ListPageCount", newPage);
    }
  };

  const handleChangeRowsPerPage = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setCurrentPage(0);
    sessionStorage.setItem("ListRowsPerPage", e.target.value);
    sessionStorage.setItem("ListPageCount", 0);
  };

  const getWhereClause = () => {
    let whereConditions = "";
    const colMap = {
      letterNumber: "letterNumber",
      clientName: "clientName",
    };
    const colName = colMap[searchBy];
    if (colName && searchKey.trim()) {
      whereConditions = `WHERE LOWER(${colName}) LIKE LOWER('%${searchKey.trim()}%')`;
    }

    whereConditions += whereConditions ? ` AND status = 1` : `WHERE status = 1`;

    return whereConditions;
  };


  const getDataQuery = () => {
    const whereClause = getWhereClause();

    return `SELECT * FROM GeneralCorrespondents ${whereClause} ORDER BY id DESC ;`;
  };

  const getCountQuery = () => {
    const whereClause = getWhereClause();

    return `SELECT COUNT(*) AS totalRows FROM GeneralCorrespondents ${whereClause};`;
  };

  const fetchData = async () => {
    try {
      const [generalCorrespondents, countResult] = await Promise.all([
        fetchQuery(getDataQuery()),
        fetchQuery(getCountQuery()),
      ]);
      const inspectionData = generalCorrespondents || [];
      setTotalRows(countResult?.[0]?.totalRows || 0);
      setCorrespondentsList(inspectionData);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  const handleSearch = () => {
    if (!searchBy || !searchKey.trim()) {
      alert("Please select a search field and enter a search value.");
      return;
    }
    fetchData();
    setSearched(true);
    // Save search state to sessionStorage
    sessionStorage.setItem("searchBy", searchBy);
    sessionStorage.setItem("searchKey", searchKey);
    sessionStorage.setItem("searched", "true");
    sessionStorage.setItem("currentPath", location.pathname);
    sessionStorage.setItem("ListPageCount", 0);
    setCurrentPage(0);
  };

  const clearSearch = () => {
    setSearched(false);
    setSearchBy("letterNumber");
    setSearchKey("");
    // Clear all employee list session storage
    sessionStorage.removeItem("ListPageCount");
    sessionStorage.removeItem("ListRowsPerPage");
    sessionStorage.removeItem("searchBy");
    sessionStorage.removeItem("searchKey");
    sessionStorage.removeItem("searched");
    setCurrentPage(0);
  };

  useEffect(() => {
    fetchData();
  }, [currentPage, rowsPerPage]);

  useEffect(() => {
    if (searched == false) {
      fetchData();
    }
  }, [searched]);

  return (
    <>
      {(permissions.create || permissions.allAccess) && (
        <AddButton
          id="btn-add-outline"
          to="/editgeneralCorrespondents/0"
          label="Add Report"
          icon={<AddIcon fontSize="small" />}
        />
      )}

      <ListSearchSection
        fields={fields}
        onSearch={handleSearch}
        searchKey={searchKey}
        setSearchKey={setSearchKey}
        searchBy={searchBy}
        setSearchBy={setSearchBy}
        clearSearch={clearSearch}
        searched={searched}
        setSearched={setSearched}
      />
      <br />

      <div className="w-full border rounded-md shadow">
        <div className="overflow-y-auto h-auto max-h-[550px]">
          <table className="min-w-full text-sm text-left text-gray-700">
            <thead className="sticky top-0 bg-blue-50 text-xs font-medium text-gray-600 z-10">
              <tr>
                {/* {hasRole && (
                  <th className="px-2 py-3 text-center">
                    <input
                      type="checkbox"
                      checked={isAllSelected}
                      onChange={handleSelectAll}
                    />
                  </th>
                )} */}
                <th className="whitespace-nowrap px-4 py-3">Sr. No.</th>
                <th className="whitespace-nowrap px-4 py-3">Letter Number</th>
                <th className="whitespace-nowrap px-4 py-3">Client Name</th>
                <th className="whitespace-nowrap px-4 py-3">Date</th>
                {(permissions.edit || permissions.delete || permissions.view || permissions.allAccess) && (
                  <th className="whitespace-nowrap px-4 py-3 text-center">Actions</th>
                )}
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {paginatedData.map((row, rowIndex) => {
                return (
                  <tr key={rowIndex} className={`px-4 py-3`}>
                    {/* {hasRole && (
                    <td className="px-2 py-2 text-center">
                      <input
                        type="checkbox"
                        disabled={!(row.subjet && !row.approvedBy)}
                        checked={selectedIds.includes(row.id)}
                        onChange={() => handleSelectRow(row.id)}
                      />
                    </td>
                  )} */}
                    <td className="px-4 py-3">
                      {currentPage * rowsPerPage + rowIndex + 1}
                    </td>
                    <td className="px-4 py-3">
                      {row.letterNumber ?? "-"}
                    </td>
                    <td className="px-4 py-3">
                      {(row.clientName?.split(" ").slice(0, 3).join(" ") + (row.clientName?.split(" ").length > 3 ? "..." : "")) || "-"}
                    </td>
                    <td className="px-4 py-3">
                      {row.date ? moment(row.date).format("DD-MM-YYYY") : "-"}
                    </td>
                    <td className="px-4 py-2 text-center whitespace-nowrap">
                      <div className="flex items-center justify-center gap-2">
                        {(permissions.edit || permissions.allAccess) && (
                          <button
                            onClick={() => handleEdit(row)}
                            className="text-blue-600"
                          >
                            <EditIcon fontSize="small" />
                          </button>
                        )}

                        {(permissions.delete || permissions.allAccess) && (
                          <button
                            onClick={() => handleDelete(row)}
                            className="text-blue-600 "
                          >
                            <DeleteIcon fontSize="small" />
                          </button>
                        )}

                        {(permissions.pdfDownload || permissions.allAccess) && (
                          <button
                            onClick={() =>
                              navigate(
                                `/editgeneralCorrespondents/print/${row.id}`
                              )
                            }
                            className="text-blue-600 "
                          >
                            <PictureAsPdfIcon fontSize="small" />
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                );
              })}
              {paginatedData.length === 0 && (
                <tr>
                  <td
                    colSpan={headers.length + 1}
                    className="text-center py-4 text-gray-500"
                  >
                    No data available.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination Footer */}
        <div className="flex items-center justify-between px-4 py-2 bg-blue-50 text-sm border-t">
          <div className="flex items-center gap-2">
            <span>Rows per page:</span>
            <select
              value={rowsPerPage}
              onChange={handleChangeRowsPerPage}
              className="border rounded px-2 py-1 text-sm"
            >
              {paginationrowsPerPageOptions.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </div>

          <div className="flex items-center gap-2">
            <span className="text-gray-600">
              {CorrespondentsList.length === 0
                ? "0–0 of 0"
                : `${currentPage * rowsPerPage + 1}–${Math.min(
                  (currentPage + 1) * rowsPerPage,
                  CorrespondentsList.length
                )} of ${CorrespondentsList.length}`}
            </span>
            <button
              onClick={() => handleChangePage(0)}
              disabled={currentPage === 0}
              className="p-1 disabled:opacity-50"
            >
              <FirstPageIcon fontSize="small" />
            </button>
            <button
              onClick={() => handleChangePage(currentPage - 1)}
              disabled={currentPage === 0}
              className="p-1 disabled:opacity-50"
            >
              <KeyboardArrowLeftIcon fontSize="small" />
            </button>
            <button
              onClick={() => handleChangePage(currentPage + 1)}
              disabled={currentPage >= totalPages - 1}
              className="p-1 disabled:opacity-50"
            >
              <KeyboardArrowRightIcon fontSize="small" />
            </button>
            <button
              onClick={() => handleChangePage(totalPages - 1)}
              disabled={currentPage >= totalPages - 1}
              className="p-1 disabled:opacity-50"
            >
              <LastPageIcon fontSize="small" />
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default GeneralCorrespondentsList;
